import { Column } from '@access-erp/common';
import { useMemo } from 'react';

import { goToRouteBySearch } from '@/components/common/EnquiriesScreen/utils/goToRouteBySearch';
import { useGetredirectLink } from '@/components/common/EnquiriesScreen/utils/useGetRedirectLink';
import { browserHistory } from '@/routing/browserHistory';
import { DataMappers } from '@/utils/DataMappers';
import { getParameterizedLink } from '@/utils/getLinkWithSubscriptionId.utils';
import { PreloadData } from '@/utils/microfrontend/preloadData';
import { getHeaderColumns } from '../columns/headerColumns';

export interface UseTransactionTableColumnsReturn {
  headerColumns: Column<any>[];
  goToSalesOrdersBySearch: (searchText?: string) => void;
}

export const useColumns = (
  isBillingCyclesPath: boolean
): UseTransactionTableColumnsReturn => {
  const getRedirectLink = useGetredirectLink();
  const billingIntervals = useMemo(() => PreloadData.billingIntervals(), []);

  const getContractLink = (contractId: string, searchString?: string) => {
    let link = getRedirectLink(window.location.pathname, contractId, searchString);
    return getParameterizedLink(link);
  };

  const goToContract = (contractLink: string) => {
    browserHistory.push(getParameterizedLink(contractLink));
  };

  const goToSalesOrdersBySearch = (searchText?: string) => {
    goToRouteBySearch(searchText);
  };

  const billingIntervalFIlterOption = DataMappers.billingIntervalsToOptionsArray(billingIntervals);

  return useMemo(() => {
    const headerColumns = getHeaderColumns({
      getContractLink,
      goToContract,
      billingIntervalFIlterOption,
      isBillingCyclesPath,
    });

    return {
      headerColumns,
      goToSalesOrdersBySearch,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
